module.exports = __webpack_public_path__ + "static/media/sample12.4eff266b.jpg";